import { withStyles } from "@material-ui/core";
import styles from "./styles";
import Detail from "./PickupDetails/Detail";

const BillingDetails = ({ classes, data }) => {
  return (
    <div className={classes.billingContainer}>
      <div className={classes.sectionTitle}>Billing Details</div>
      <div className={classes.billInfoContainer}>
        <Detail title="Bill To Code:" value={data.billToCode} />
        <Detail title="Bill To Name:" value={data.billToName} />
        <Detail title="Reference #" value={data.pickupReferenceNumber} />
        <Detail title="Quote #:" value={data.quoteNumber} />
      </div>
    </div>
  );
};

export default withStyles(styles)(BillingDetails);
